import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "customer-Edit-dialog modal-footer"
};
var _hoisted_2 = {
  key: 0,
  class: "checkbox-container"
};
var _hoisted_3 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_divider = _resolveComponent("el-divider");

  var _component_el_checkbox = _resolveComponent("el-checkbox");

  var _component_CustomerEditForm = _resolveComponent("CustomerEditForm");

  var _component_el_scrollbar = _resolveComponent("el-scrollbar");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.modalVisibility,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return _ctx.modalVisibility = $event;
    }),
    width: "80%"
  }, {
    title: _withCtx(function () {
      return [_createElementVNode("h2", null, _toDisplayString(_ctx.$t("customers.edit")), 1), _createVNode(_component_el_divider, {
        class: "mb-0"
      })];
    }),
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
        class: "py-5 px-6",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.toggleModalVisible(_ctx.customerModalStatus);
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.go-back")), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        class: "py-5 px-6",
        type: "primary",
        loading: _ctx.isLoading,
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.onSave();
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.save")), 1)];
        }),
        _: 1
      }, 8, ["loading"])])];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_el_scrollbar, {
        "max-height": _ctx.maxHeight
      }, {
        default: _withCtx(function () {
          return [!_ctx.isSelectedCustomer ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_checkbox, {
            modelValue: _ctx.saveAndAssign,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.saveAndAssign = $event;
            }),
            border: true
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("customers.assign-to-order")), 1)];
            }),
            _: 1
          }, 8, ["modelValue"])])) : _createCommentVNode("", true), _createVNode(_component_CustomerEditForm, {
            ref: "customerEditForm"
          }, null, 512)];
        }),
        _: 1
      }, 8, ["max-height"])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}